import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import SitiWeb from "@/pages/SitiWeb";
import Consulenze from "@/pages/Consulenze";
import NfcRecensioni from "@/pages/NfcRecensioni";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Prenota from "@/pages/Prenota";
import ConfermaPrenotazione from "@/pages/ConfermaPrenotazione";
import GestionePrenotazione from "@/pages/GestionePrenotazione";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // SPA: la sezione potrebbe non essere ancora renderizzata — riprova qualche volta
      let attempts = 0;
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        } else if (attempts++ < 20) {
          setTimeout(tryScroll, 150);
        }
      };
      setTimeout(tryScroll, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
};

const Shell = ({ children }) => (
  <div className="flex min-h-screen flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/servizi" element={<Shell><Servizi /></Shell>} />
          <Route path="/siti-web" element={<Shell><SitiWeb /></Shell>} />
          <Route path="/consulenze" element={<Shell><Consulenze /></Shell>} />
          <Route path="/recensioni-nfc" element={<Shell><NfcRecensioni /></Shell>} />
          <Route path="/blog" element={<Shell><Blog /></Shell>} />
          <Route path="/blog/:slug" element={<Shell><BlogPost /></Shell>} />
          <Route path="/chi-siamo" element={<Shell><ChiSiamo /></Shell>} />
          <Route path="/contatti" element={<Shell><Contatti /></Shell>} />
          <Route path="/prenota" element={<Shell><Prenota /></Shell>} />
          <Route path="/prenota/conferma/:id" element={<Shell><ConfermaPrenotazione /></Shell>} />
          <Route path="/prenotazione/:id" element={<Shell><GestionePrenotazione /></Shell>} />
          <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
          <Route path="/cookie-policy" element={<Shell><CookiePolicy /></Shell>} />
          <Route path="/admin/:secret" element={<Admin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Shell><NotFound /></Shell>} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
